<template>
  <div
    class="select"
    :class="[ isMini && 'select--mini']"
  >
    <select
      v-if="checkOptions"
      :id="id"
      class="select__control"
      :name="name"
      :required="isRequired"
      @change="onChange"
    >
      <option
        v-if="placeholder"
        value=""
        hidden
      >
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :selected="option.value === value"
      >
        {{ option.label }}
      </option>
    </select>
    <span class="select__chevron-wrap">
      <v-icon
        class="select__chevron"
        type="angle-down"
      />
    </span>
  </div>
</template>


<script>
  import Icon from "../Icon";

  export default {
    name: "Select",
    components: {
      "v-icon": Icon,
    },
    props: {
      id: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      isRequired: {
        type: Boolean,
        default: false
      },
      isMini: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default: () => {
          return [];
        }
      },
      value: {
        type: [String, Number],
        default: null
      }
    },
    computed: {
      checkOptions() {
        if (this.options.length) {
          return this.options;
        } else {
          this.$notify({
            title: 'Error',
            text: this.name + " couldn't render without options.",
            type: 'error'
          });
          return false;
        }
      }
    },
    methods: {
      onChange(selected) {
        this.$emit("change", selected.target.value);
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .select {
    $this: &;
    position: relative;
    margin-bottom: 0;
    font-size: $input-font-size;
    &__control {
      width: 100%;
      border: 1px solid $pigeon;
      border-radius: $form-border-radius;
      padding: $input-padding ($input-padding + 2rem) $input-padding $input-padding;
      box-shadow: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      background-color: $white;
      color: inherit;
      outline: none;
      cursor: pointer;
      transition: box-shadow 0.3s, border 0.3s;
      font-size: inherit;
      &:disabled,
      &[readonly="readonly"] {
        color: $casper;
        border-color: $casper;
        background: $zircon;
      }
      &:focus:not([readonly]) {
        box-shadow: 0 0 0 3px rgba($pigeon, 0.5);

      }
      &:focus:active:not([readonly]) + #{$this}__chevron-wrap #{$this}__chevron {
        transform: rotate(-180deg);
        @include transitionIn();
      }
      //placeholder only works when select is required
      &:not(:focus):invalid {
        color: $casper;
      }
    }
    &--mini {
      font-size: $font-size-sm;
      #{$this}__chevron-wrap {
        width: 2rem;
        background-color: transparent;
      }
      #{$this}__control {
        padding: 5px 10px;
      }
    }
    &__chevron-wrap {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.5rem;
      text-align: center;
      border-top-right-radius: $form-border-radius;
      border-bottom-right-radius: $form-border-radius;
      background-color: $pigeon;
      pointer-events: none;
      font-size: 2em;
    }
    &__chevron {
      line-height: 1;
      transform: rotate(0);
      @include transitionOut();
    }
  }
</style>
